<template>
  <v-app-bar color="primary" dark app>
    <v-app-bar-nav-icon @click="handleDrawerToggle" />
    <v-spacer />
    <v-toolbar-items>
      <v-btn icon large @click="handleFullScreen()">
        <v-icon>mdi-fullscreen</v-icon>
      </v-btn>
      <v-menu offset-y origin="center center" :nudge-bottom="10" transition="scale-transition">
        <template v-slot:activator="{ on }">
          <v-btn icon large slot="activator" v-on="on">
            <v-icon>mdi-account</v-icon>
          </v-btn>
        </template>
        <v-list class="pa-0">
          <v-list-item
            v-for="(item, index) in items"
            :to="!item.href ? { name: item.name } : null"
            :href="item.href"
            @click="item.click"
            ripple="ripple"
            :disabled="item.disabled"
            :target="item.target"
            rel="noopener"
            :key="index"
          >
            <v-list-item-action v-if="item.icon">
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-toolbar-items>
  </v-app-bar>
</template>
<script>
import Util from "@/util";
export default {
  name: "AppToolbar",
  components: {},
  data() {
    return {
      items: [
        {
          icon: "mdi-account-circle",
          title: "Mi perfil",
          click: this.handleProfile
        },
        {
          icon: "mdi-logout-variant",
          title: "Salir",
          click: this.handleLogut
        }
      ]
    };
  },
  computed: {},
  methods: {
    handleDrawerToggle() {
      this.$emit("side-icon-click");
    },
    handleFullScreen() {
      Util.toggleFullScreen();
    },
    handleLogut() {
      localStorage.clear();
      this.$router.replace({ name: "login" });
    },
    handleProfile() {
      this.$router.push({ name: "my-profile" });
    }
  },
  created() {}
};
</script>

<style lang="sass" scoped></style>
